module.exports = __webpack_public_path__ + "img/BannerNew.68579a2c.png";